import { render } from "./newActivity.vue?vue&type=template&id=54101069&scoped=true"
import script from "./newActivity.vue?vue&type=script&lang=js"
export * from "./newActivity.vue?vue&type=script&lang=js"

import "./newActivity.vue?vue&type=style&index=0&id=54101069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54101069"]])

export default __exports__